import { render, staticRenderFns } from "./NewManual.vue?vue&type=template&id=1d98bab0&scoped=true"
import script from "./NewManual.vue?vue&type=script&lang=js"
export * from "./NewManual.vue?vue&type=script&lang=js"
import style0 from "./NewManual.vue?vue&type=style&index=0&id=1d98bab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98bab0",
  null
  
)

export default component.exports